import React from "react"
import { Link } from "gatsby"
import { globalHistory } from "@reach/router"
import { Title, UnstyledButton, Group } from "@mantine/core"

const Logo = ({ siteTitle }) => {
    
    // Ελέγχουμε αν βρισκόμαστε στην Αρχική σελίδα
    const path = globalHistory.location.pathname
    const isHomePage = path === '/'

    // 💡 Εδώ μελλοντικά, αν φέρεις το Logo από το WP (μέσω GraphQL), 
    // θα το αποθηκεύσεις σε αυτή τη μεταβλητή. Προς το παρόν είναι null.
    const wpLogoImage = null; 

    // Η Λογική: Τι θα δείξουμε; Εικόνα ή Κείμενο;
    const logoContent = wpLogoImage ? (
        // Αν ΥΠΑΡΧΕΙ εικόνα (μελλοντικά)
        <img src={wpLogoImage} alt={`${siteTitle} Logo`} style={{ height: '50px', objectFit: 'contain' }} />
    ) : (
        // Αν ΔΕΝ ΥΠΑΡΧΕΙ εικόνα, δείχνουμε το όνομα του Site (Text Logo)
        <Title 
            order={3} 
            style={{ 
                fontFamily: 'var(--mantine-font-family-headings)', 
                color: 'var(--mantine-color-brandBlue-filled)', // Χρησιμοποιεί το βασικό σου μπλε
                fontSize: '2rem', // Responsive μέγεθος
                margin: 0
            }}
        >
            {siteTitle}
        </Title>
    );

    return (
        <Group align="center">
            {isHomePage ? (
                // Αν είμαστε στην αρχική, το λογότυπο ΔΕΝ είναι clickable link (best practice)
                <div style={{ cursor: 'default' }}>
                    {logoContent}
                </div>
            ) : (
                // Στις άλλες σελίδες, το λογότυπο είναι Link προς την αρχική!
                <UnstyledButton component={Link} to="/" style={{ textDecoration: 'none' }}>
                    {logoContent}
                </UnstyledButton>
            )}
        </Group>
    )
}

export default Logo
